import { SHARED_FOLDERS_TREE_TYPE, isFolderOfTreeType } from 'owa-folders';

export default function isSharedFolder(folderId: string): boolean {
    return isFolderOfTreeType(folderId, SHARED_FOLDERS_TREE_TYPE);
}
